import React from "react";
import Home from "../components/home/Home";
import About from "../components/about/About";
import Skills from "../components/skills/Skills";
import Services from "../components/services/Services";
import Qualification from "../components/qualification/Qualification";
import Work from "../components/work/Work";
import Contact from "../components/contact/Contact";
import ScrollUp from "../components/scrollUp/ScrollUp";

const Landingpage = () => {
  return (
    <>
      <main className="main mx-4">
        <Home />
        <About />
        <Skills />
        <Services />
        <Qualification />
        <Work />
        {/* <Testimonials /> */}
        <Contact />
      </main>
      <ScrollUp />
    </>
  );
};

export default Landingpage;
